import { useComputed, useSignal } from '@preact/signals'
import { useEffect } from 'preact/hooks'

import { Typography, Button } from 'components'
import { setSmartContractModalState } from 'pages/home/state'
import { areProjectsLoadingState, smartContractsState } from 'state'
import { loadObjectFromLocalStorage } from 'utils'
import { LocalStorageKeys } from 'types'

import { PendingCollaborationsContainer } from './PendingCollaborationsContainer'

const GettingStartedCard = () => {
	const pendingInvitations = useSignal<null | string[]>(null)

	useEffect(() => {
		const pendingInvitationsObject = loadObjectFromLocalStorage<
			Record<string, string>
		>(LocalStorageKeys.CollaboratorInvitationProjects)

		if (pendingInvitationsObject) {
			pendingInvitations.value = Object.keys(pendingInvitationsObject)
		} else {
			pendingInvitations.value = null
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [])

	const displayCreateFirstSmartContractCard = useComputed(
		() =>
			(pendingInvitations.value === null ||
				pendingInvitations.value.length === 0) &&
			areProjectsLoadingState.value === false &&
			smartContractsState.value.length === 0
	)

	return (
		<>
			{displayCreateFirstSmartContractCard.value && (
				<section class='mb-5'>
					<div class='flex items-center justify-between gap-4 rounded-md bg-black-800 p-6'>
						<Typography
							class='text-[1.125rem] leading-[1.575rem]'
							color='text-black-100'
							text='Create your first Smart Contract and start coding right away.'
							variant='h4'
							weight='font-semibold'
						/>
						<Button
							className='min-w-28'
							onClick={() => setSmartContractModalState(true)}
							text='Get started'
						/>
					</div>
				</section>
			)}

			{pendingInvitations.value !== null && (
				<PendingCollaborationsContainer
					pendingInvitations={pendingInvitations}
				/>
			)}
		</>
	)
}

export { GettingStartedCard }
